export * from "./prePassRenderer.pure";
